<div class="row">
    <ng-container *ngIf="requestIsSubscribed">
        <a class="col-sm-3 btn-org " *ngFor="let s of requestIsSubscribed"
            (click)="changeTypeOfSubscription(s.id,s.subscribed, s.status)"
            [ngClass]="{'active': selectedItem == s.id}">{{s.title}}</a>
    </ng-container>
</div>
<br>
<div class="row">
    <div class="col-sm-6">
        <h4>Lista de suscriptores</h4>
    </div>
    <div class="col-sm-6">
        <button style="float: right;" class="btn-add" (click)="downloadExcel()">Exportar a Excel</button>
    </div>
</div>

<div class="row">
    <div class="table-responsive">
        <table class="table table-hover">
            <thead class="thead-detail text-center table-success">
                <tr>
                    <th scope="col">N°</th>
                    <th scope="col">Nombre</th>
                    <th scope="col">Apellido paterno</th>
                    <th scope="col">Apellido materno</th>
                    <th scope="col">Email</th>
                    <th scope="col">Estado</th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                </tr>
            </thead>
            <tbody>
                <tr class="tbody-detail" *ngFor="let s of subscription; let i = index">
                    <td>{{ i + 1 }}</td>
                    <td>{{ s.name }}</td>
                    <td>{{ s.lastname }}</td>
                    <td>{{ s.surname }}</td>
                    <td>{{ s.email }}</td>
                    <td class="text-center">
                        <div class="text-warning text-center" *ngIf="s.status=='0' && s.subscribed=='1' ">PENDIENTE
                        </div>
                        <div class="label-active text-center" *ngIf="s.status=='1' && s.subscribed=='1'">ACEPTADO</div>
                        <div class="label-inactive text-center" *ngIf="s.status=='0' && s.subscribed=='0'">RECHAZADO
                        </div>
                    </td>
                    <td>
                        <a class="a-icon text-center" title="Aceptar suscripción"
                            *ngIf="s.subscribed=='1'&& s.status=='0' || s.subscribed=='0'&& s.status=='0'"
                            (click)="editStatusSubscription(s.id, '1','1', s.email)"><i
                                class="fa fa-check-circle i-icon"></i></a>
                    </td>
                    <td>
                        <a class="a-icon text-center" title="Rechazar suscripción"
                            *ngIf="s.subscribed=='1'&& s.status=='0' || s.subscribed=='1'&& s.status=='1'"
                            (click)="editStatusSubscription(s.id, '0','0', s.email)"><i
                                class="fa fa-trash i-icon"></i></a>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>